import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
export const API_BASE = `${BACKEND_URL}/api`;


export const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

export const apiFile = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
  responseType: "blob",
});

export const CATEGORIES_EXPENSE = [
  "Advertising",
  "Auto & Travel",
  "Cleaning & Maintenance",
  "Commissions",
  "Insurance",
  "Legal & Professional",
  "Management Fees",
  "Meals & Entertainment",
  "Mortgage Interest",
  "Other Interest",
  "Repairs",
  "Supplies",
  "Taxes",
  "Utilities",
  "Depreciation",
  "Other",
  "Consumables/Toiletries",
  "Professional Cleaning",
  "Platform Fees",
  "Guest Supplies",
  "Capital Contribution",
  "Owner Draw",
  "Due to Member",
];

export const CATEGORIES_INCOME = [
  "Rent",
  "STR Booking",
  "Late Fee",
  "Security Deposit",
  "Other Income",
];

export const US_STATES = [
  { code: "AL", name: "Alabama" },
  { code: "AK", name: "Alaska" },
  { code: "AZ", name: "Arizona" },
  { code: "AR", name: "Arkansas" },
  { code: "CA", name: "California" },
  { code: "CO", name: "Colorado" },
  { code: "CT", name: "Connecticut" },
  { code: "DE", name: "Delaware" },
  { code: "FL", name: "Florida" },
  { code: "GA", name: "Georgia" },
  { code: "HI", name: "Hawaii" },
  { code: "ID", name: "Idaho" },
  { code: "IL", name: "Illinois" },
  { code: "IN", name: "Indiana" },
  { code: "IA", name: "Iowa" },
  { code: "KS", name: "Kansas" },
  { code: "KY", name: "Kentucky" },
  { code: "LA", name: "Louisiana" },
  { code: "ME", name: "Maine" },
  { code: "MD", name: "Maryland" },
  { code: "MA", name: "Massachusetts" },
  { code: "MI", name: "Michigan" },
  { code: "MN", name: "Minnesota" },
  { code: "MS", name: "Mississippi" },
  { code: "MO", name: "Missouri" },
  { code: "MT", name: "Montana" },
  { code: "NE", name: "Nebraska" },
  { code: "NV", name: "Nevada" },
  { code: "NH", name: "New Hampshire" },
  { code: "NJ", name: "New Jersey" },
  { code: "NM", name: "New Mexico" },
  { code: "NY", name: "New York" },
  { code: "NC", name: "North Carolina" },
  { code: "ND", name: "North Dakota" },
  { code: "OH", name: "Ohio" },
  { code: "OK", name: "Oklahoma" },
  { code: "OR", name: "Oregon" },
  { code: "PA", name: "Pennsylvania" },
  { code: "RI", name: "Rhode Island" },
  { code: "SC", name: "South Carolina" },
  { code: "SD", name: "South Dakota" },
  { code: "TN", name: "Tennessee" },
  { code: "TX", name: "Texas" },
  { code: "UT", name: "Utah" },
  { code: "VT", name: "Vermont" },
  { code: "VA", name: "Virginia" },
  { code: "WA", name: "Washington" },
  { code: "WV", name: "West Virginia" },
  { code: "WI", name: "Wisconsin" },
  { code: "WY", name: "Wyoming" },
  { code: "DC", name: "District of Columbia" },
];

export const formatCurrency = (n) =>

  new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 0 }).format(n || 0);

export const formatCurrencyPrecise = (n) =>
  new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(n || 0);

export const formatCompactCurrency = (n) => {
  if (n === null || n === undefined) return "—";
  const abs = Math.abs(n);
  const sign = n < 0 ? "-" : "";
  if (abs >= 1_000_000) {
    const formatted = (abs / 1_000_000).toFixed(2).replace(/\.00$/, "").replace(/(\.[0-9])0$/, "$1");
    return `${sign}$${formatted}M`;
  }
  if (abs >= 100_000) {
    const formatted = (abs / 1_000).toFixed(1).replace(/\.0$/, "");
    return `${sign}$${formatted}K`;
  }
  return new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 0 }).format(n);
};

export const formatDate = (iso) => {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" });
  } catch {
    return iso;
  }
};

export const getReceiptUrl = (receiptPath) => {
  if (!receiptPath) return "";
  if (receiptPath.startsWith("http://") || receiptPath.startsWith("https://")) return receiptPath;
  const clean = receiptPath.startsWith("/") ? receiptPath.slice(1) : receiptPath;
  return `/data/${clean}`;
};

export async function compressImage(file, maxDimension = 1800, quality = 0.85) {
  if (!file || !file.type || !file.type.startsWith("image/") || file.type.includes("svg") || file.type === "application/pdf" || file.name?.toLowerCase().endsWith(".pdf")) {
    return file;
  }
  if (file.size < 750 * 1024) {
    return file;
  }

  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      const img = new Image();
      img.onload = () => {
        let { width, height } = img;
        if (width > maxDimension || height > maxDimension) {
          if (width > height) {
            height = Math.round((height * maxDimension) / width);
            width = maxDimension;
          } else {
            width = Math.round((width * maxDimension) / height);
            height = maxDimension;
          }
        }
        const canvas = document.createElement("canvas");
        canvas.width = width;
        canvas.height = height;
        const ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0, width, height);
        canvas.toBlob(
          (blob) => {
            if (blob && blob.size < file.size) {
              const compressedFile = new File([blob], file.name.replace(/\.[^.]+$/, ".jpg"), {
                type: "image/jpeg",
                lastModified: Date.now(),
              });
              resolve(compressedFile);
            } else {
              resolve(file);
            }
          },
          "image/jpeg",
          quality
        );
      };
      img.onerror = () => resolve(file);
      img.src = e.target.result;
    };
    reader.onerror = () => resolve(file);
    reader.readAsDataURL(file);
  });
}

export function getErrorMessage(err, fallback = "An unexpected error occurred") {
  if (!err) return fallback;
  const detail = err?.response?.data?.detail;
  if (detail) {
    if (typeof detail === "string") return detail;
    if (Array.isArray(detail)) {
      return detail
        .map((d) => d?.msg || (typeof d === "object" ? JSON.stringify(d) : String(d)))
        .join("; ") || fallback;
    }
    if (typeof detail === "object") {
      return detail.message || detail.msg || JSON.stringify(detail);
    }
    return String(detail);
  }
  const message = err?.response?.data?.message || err?.message;
  if (typeof message === "string" && message) return message;
  return fallback;
}



